var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".edit-icon-a{fill:#fff;stroke:#707070;opacity:0;}.edit-icon-b{fill:#acb5c0;}.edit-icon-c{stroke:none;}.edit-icon-d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "edit-icon-a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "edit-icon-c",
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "edit-icon-d",
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.436)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "edit-icon-b",
    d: "M0,75.988v2.744H2.744l8.1-8.1L8.1,67.893Z",
    transform: "translate(0 -65.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "edit-icon-b",
    d: "M262.749,1.922,261.04.214a.733.733,0,0,0-1.035,0l-1.339,1.339L261.41,4.3l1.339-1.339A.733.733,0,0,0,262.749,1.922Z",
    transform: "translate(-249.795 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.00a9330d6462f8d39e8f3fe9884109ef.svg";
export { ForwardRef as ReactComponent };